export default {
  setActiveIncidents(state, incidents) {
    state.activeIncidents = incidents.map((incident) => ({
      ...incident,
      showTimeline: false,
    }));
  },

  setResolvedIncidents(state, incidents) {
    state.resolvedIncidents = incidents.map((incident) => ({
      ...incident,
      showTimeline: false,
    }));
  },

  setEndpoints(state, endpoints) {
    state.endpoints = endpoints;
  },

  toggleActiveTimeline(state, index) {
    state.activeIncidents[index].showTimeline = !state.activeIncidents[index].showTimeline;
  },

  toggleResolvedTimeline(state, index) {
    state.resolvedIncidents[index].showTimeline = !state.resolvedIncidents[index].showTimeline;
  },

  setLoading(state, loading) {
    state.loading = loading;
  },

  setError(state, error) {
    state.error = error;
  },
};
